import { render, staticRenderFns } from "./component_detection_img_pc.vue?vue&type=template&id=e0d1d938&scoped=true&"
import script from "./component_detection_img_pc.vue?vue&type=script&lang=js&"
export * from "./component_detection_img_pc.vue?vue&type=script&lang=js&"
import style0 from "./component_detection_img_pc.vue?vue&type=style&index=0&id=e0d1d938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d1d938",
  null
  
)

export default component.exports